export default "__VITE_ASSET__oV_JoGTH__"